// import config from '../../public/config';

const settings = {
    // baseUrl: config.baseUrl,// process.env.VUE_APP_BASEURL,
    // baseUrlApi: config.baseUrlApi, // process.env.VUE_APP_BASEAPIURL,
    // tokenName: config.tokenName,
    // permissionTokenName: config.permissionTokenName,
    // tenantId: config.tenantId,
    // clientId: config.clientId

    baseUrl: process.env.VUE_APP_BASEURL,
    baseUrlApi: process.env.VUE_APP_BASEAPIURL,
    tokenName: 'su-esv-token',
    permissionTokenName: 'su-esv-rpm',
    tenantId: process.env.VUE_APP_TENANTID,
    clientId: process.env.VUE_APP_CLIENTID
}

export default settings